<template>
  <div id="app">
      <router-view></router-view>
      <Footer></Footer>
  </div>
</template>

<script>
import Footer from './components/footer/footer'
import '../static/css/reset.css'

export default {
  name: 'App',
  data(){
    return {
      renderContent:this.$route.params.renderContent?this.$route.params.renderContent:0,
    }
  },
  components:{
    // KnowUs,
    // Team,
    // FundClassify,
    // InvestCase,
    // News,
    // ContactUs,
    // NewsMore,
    Footer,
  }
}
</script>

<style scoped>

body{
  background: #fff;
}
</style>




// WEBPACK FOOTER //
// src/App.vue